var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCountryflag5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10579_209366)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.7694,
    height: 16.7694,
    transform: "translate(0.929688 0.480469)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31438 17.2499C13.9451 17.2499 17.6991 13.4959 17.6991 8.86516C17.6991 4.23442 13.9451 0.480469 9.31438 0.480469C4.68364 0.480469 0.929688 4.23442 0.929688 8.86516C0.929688 13.4959 4.68364 17.2499 9.31438 17.2499Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31443 0.480469C5.99022 0.480469 3.11794 2.41501 1.76172 5.21965H16.8671C15.5109 2.41501 12.6386 0.480469 9.31443 0.480469Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31443 17.249C5.99022 17.249 3.11794 15.3144 1.76172 12.5098H16.8671C15.5109 15.3144 12.6386 17.249 9.31443 17.249Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3031 6.3125H1.32563C1.06879 7.1172 0.929688 7.9745 0.929688 8.86436C0.929688 9.75422 1.06879 10.6115 1.32563 11.4162H17.3031C17.56 10.6115 17.6991 9.75422 17.6991 8.86436C17.6991 7.9745 17.56 7.1172 17.3031 6.3125Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9249 4.35675L10.9319 3.89844L9.31401 7.56186L7.69609 3.89844L6.70312 4.35675L8.71178 8.86676L6.70312 13.3768L7.69609 13.8351L9.31401 10.1717L10.9319 13.8351L11.9249 13.3768L9.91623 8.86676L11.9249 4.35675Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.98945 4.78807C9.60506 4.36827 9.31504 4.12695 9.31504 4.12695C9.31504 4.12695 9.02501 4.36824 8.64062 4.78807V12.9441C9.02501 13.364 9.31504 13.6053 9.31504 13.6053C9.31504 13.6053 9.60506 13.364 9.98945 12.9442V4.78807Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49219 6.35117V11.3791C7.89839 12.0988 8.39554 12.6888 8.76813 13.0799V4.65039C8.39554 5.04149 7.89835 5.63147 7.49219 6.35117Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1392 6.35117C10.733 5.63143 10.2359 5.04149 9.86328 4.65039V13.0799C10.2358 12.6888 10.733 12.0988 11.1392 11.3791V6.35117Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1367 6.35156V11.3795C11.5479 10.6508 11.8658 9.78909 11.8658 8.86556C11.8658 7.94203 11.5479 7.08031 11.1367 6.35156Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49083 6.35156V11.3795C7.07962 10.6508 6.76172 9.78909 6.76172 8.86556C6.76172 7.94203 7.07962 7.08031 7.49083 6.35156Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10579_209366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.7694,
    height: 16.7694,
    fill: "white",
    transform: "translate(0.929688 0.480469)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryflag5);
export default __webpack_public_path__ + "static/media/Countryflag5.be8d87acdf741db8be7a4cdcc1201e9e.svg";
export { ForwardRef as ReactComponent };